import { formatChatFileSize } from './chat-file-limits'

/** What one contacts file imported into a mailbox (#1120) may hold: the figures both the portal and the API read. */
export type MailContactsImportLimits = {
    /** The most bytes one file may hold, inclusive. */
    maxBytes: number
    /** The most distinct addresses one file may hold, inclusive. */
    maxContacts: number
}

/**
 * The one published contract for a contacts import (#1120): a CSV or vCard file of 1 MB and 5,000 addresses at most,
 * both inclusive. A whole address book exported from a mail service is well under both; a larger file is refused
 * whole, never imported in part.
 */
export const MAIL_CONTACTS_IMPORT_LIMITS: MailContactsImportLimits = { maxBytes: 1024 * 1024, maxContacts: 5000 }

/** The limits as one phrase a person reads before importing: `up to 1 MB and 5,000 contacts`. */
export function mailContactsImportLimitsSentence(
    limits: MailContactsImportLimits = MAIL_CONTACTS_IMPORT_LIMITS,
): string {
    return `up to ${formatChatFileSize(limits.maxBytes)} and ${limits.maxContacts.toLocaleString('en-GB')} contacts`
}
